<template>
  <Card class="layout-card">
    <div class="search-form">
      <Input v-model="searchForm.id" placeholder="请输入短剧 ID" clearable />
      <Input v-model="searchForm.keyword" placeholder="请输入所属主剧或短剧名称" clearable />
      <Select v-model="searchForm.langId" placeholder="请选择语言" clearable @on-change="handleSearchLangChange">
        <Option v-for="item in langList" :key="item.id" :value="item.id">{{ item.chineseLangName }}</Option>
      </Select>
      <Select v-model="searchForm.playRelease" placeholder="请选择发布状态" clearable>
        <Option :value="1">已发布</Option>
        <Option :value="0">未发布</Option>
        <Option :value="2">待发布</Option>
        <Option :value="3">已下架</Option>
      </Select>
      <Select v-model="searchForm.configStatus" placeholder="请选择配置状态" clearable>
        <Option :value="1">已完善</Option>
        <Option :value="0">待完善</Option>
      </Select>
      <Select v-model="searchForm.playUnlockType" placeholder="请选择解锁方式" clearable>
        <Option :value="0">广告解锁</Option>
        <Option :value="1">金币解锁</Option>
        <Option :value="2">VIP 解锁</Option>
        <Option :value="3">免费解锁</Option>
      </Select>
      <Select
        v-model="searchForm.playTypeList"
        placeholder="请选择 APP 分类"
        :disabled="!searchForm.langId"
        clearable
        multiple
        :max-tag-count="2"
      >
        <Option v-for="item in searchTypeList" :key="item.id" :value="item.id">
          {{ item.typeNameCn }}({{ item.typeName }})
        </Option>
      </Select>
      <Select v-model="searchForm.subscript" placeholder="请选择角标" clearable>
        <Option :value="-1">无</Option>
        <Option :value="0">HOT</Option>
        <Option :value="1">NEW</Option>
        <Option :value="2">Dubbed</Option>
        <Option :value="3">Exclusive</Option>
        <Option :value="4">Animation</Option>
      </Select>
      <OpsGenreTagPicker
        class="content-tag-filter"
        v-model="searchForm.contentTagIds"
        :groups="tagGroups"
        :limit="10"
      />
      <Button type="primary" v-if="buttonMenu['/play/view']" @click="getData()">查询</Button>
      <Button @click="handleReset">重置</Button>
      <Button type="info" @click="handleOpenEditAddress" :disabled="!selection.length">
        批量修改可广告解锁集数
      </Button>
      <Button type="warning" @click="handleOpenOfflineModal" :disabled="!selection.length">
        批量下架
      </Button>
    </div>

    <div class="table-wrapper">
      <Table
        :data="tableData"
        :columns="columns"
        :loading="loading"
        :max-height="700"
        @on-selection-change="selection = $event"
      >
        <template #img="{ row }">
          <div class="cover-cell">
            <img
              v-if="row.fileUrl"
              :src="row.fileUrl"
              @click="$viewerApi({ images: [row.fileUrl] })"
            />
            <span v-else>—</span>
          </div>
        </template>
        <template #playRelease="{ row }">
          <div>
            <div>{{ row.playReleaseName || displayRelease(row.playRelease) }}</div>
            <template v-if="Number(row.playRelease) === 3">
              <div v-if="getOfflineTime(row)" class="release-time offline-time">
                下架时间：{{ getOfflineTime(row) }}
              </div>
            </template>
            <template v-else-if="Number(row.playRelease) === 1">
              <div v-if="row.releaseDate || row.scheduledReleaseTime" class="release-time">
                {{ row.releaseDate || row.scheduledReleaseTime }}
              </div>
              <div v-if="getOfflineTime(row)" class="release-time offline-time">
                下架时间：{{ getOfflineTime(row) }}
              </div>
            </template>
            <template v-else>
              <div v-if="row.releaseDate || row.scheduledReleaseTime" class="release-time">
                {{ row.releaseDate || row.scheduledReleaseTime }}
              </div>
            </template>
          </div>
        </template>
        <template #contentTag="{ row }">
          <Poptip
            v-if="row.contentTagName"
            trigger="hover"
            transfer
            placement="top"
            :content="row.contentTagName"
          >
            <div class="content-tag-text">{{ row.contentTagName }}</div>
          </Poptip>
          <span v-else>—</span>
        </template>
        <template #action="{ row }">
          <div class="action-list">
            <a v-if="buttonMenu['/play/edit']" @click="handleOpenEditModal(row)">编辑运营配置</a>
            <a @click="$refs.promoteModalRef.open(row)">推剧封面</a>
            <a @click="handleOpenEditEpisode(row)">剧集管理</a>
            <a style="margin-top: 5px" @click="handleOpenAdMaterial(row)"
              >广告素材</a
            >
            <a :disabled="!row.releaseTotal" @click="handlePreviewSeries(row)">在线预览</a>
          </div>
        </template>
        <Pages slot="footer" :page="page" :func="getData"></Pages>
      </Table>
    </div>

    <Modal
      v-model="editVisible"
      title="编辑短剧运营配置"
      :mask-closable="false"
      :width="900"
      class="play-edit-modal"
    >
      <Spin v-if="detailLoading" fix></Spin>
      <Form v-if="editVisible" ref="formRef" :model="form" :rules="operationRules" :label-width="140" @submit.native.prevent>
        <div class="content-info-card">
          <div class="content-info-header">
            <div class="content-info-title">
              <span>内容信息</span>
              <Tag color="default" style="margin-left: 8px;">只读</Tag>
            </div>
            <div class="content-info-sync">
              最近同步：{{ displayValue(contentInfo.lastSyncTime) }}
            </div>
          </div>
          <div class="content-info-body">
            <div class="content-info-row content-info-row-fields">
              <div class="content-info-item">
                <span class="content-info-label">所属主剧</span>
                <span class="content-info-value">{{ displayValue(contentInfo.parentPlayName) }}</span>
              </div>
              <div class="content-info-item">
                <span class="content-info-label">短剧名称</span>
                <span class="content-info-value">{{ displayValue(contentInfo.playName) }}</span>
              </div>
              <div class="content-info-item">
                <span class="content-info-label">语言</span>
                <span class="content-info-value">{{ displayValue(contentInfo.langName) }}</span>
              </div>
              <div class="content-info-item">
                <span class="content-info-label">总集数</span>
                <span class="content-info-value">{{ displayValue(contentInfo.playTotal) }}</span>
              </div>
              <div class="content-info-item">
                <span class="content-info-label">默认二卡</span>
                <span class="content-info-value">{{ displayValue(contentInfo.secondPayPoint) }}</span>
              </div>
            </div>
            <div class="content-info-divider"></div>
            <div class="content-info-row content-info-row-desc">
              <div class="content-info-item content-info-item-full">
                <span class="content-info-label">推荐语</span>
                <span class="content-info-value content-info-value-desc">{{ displayValue(contentInfo.playDesc) }}</span>
              </div>
            </div>
          </div>
        </div>

        <Divider orientation="left">APP 运营配置</Divider>
        <Row :gutter="24">
          <Col :span="12">
            <FormItem label="短剧名称：" prop="playName" :label-width="100" :rules="[{ required: true, message: '请输入短剧名称', trigger: 'blur' }]">
              <Input v-model="form.playName" placeholder="请输入短剧名称" />
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem label="默认二卡：" prop="secondPayPoint" :label-width="100">
              <Input v-model="form.secondPayPoint" placeholder="请输入默认二卡" />
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="24">
          <Col :span="24">
            <FormItem label="封面：" :label-width="100">
              <div class="cover-upload-wrapper">
                <div v-if="form.fileUrl" class="cover-preview">
                  <img :src="form.fileUrl" @click="$viewerApi({ images: [form.fileUrl] })" />
                </div>
                <PopupUpload
                  mode="custom"
                  :value="form.fileUrl"
                  @on-success="handleCoverUploadSuccess"
                >
                  <Button size="small" style="margin-left: 12px;">重新上传</Button>
                </PopupUpload>
              </div>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="24">
          <Col :span="24">
            <FormItem label="推荐语：" :label-width="100">
              <Input v-model="form.playDesc" type="textarea" :rows="3" placeholder="请输入推荐语" />
            </FormItem>
          </Col>
        </Row>

        <Row :gutter="16">
          <Col :span="12">
            <FormItem label="APP 分类：" prop="playTypeList">
              <Select
                v-model="form.playTypeList"
                placeholder="请选择 APP 分类"
                multiple
                filterable
                clearable
                transfer
                :max-tag-count="2"
              >
                <Option v-for="item in editTypeList" :key="item.id" :value="item.id">
                  {{ item.typeNameCn }}({{ item.typeName }})
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem label="角标：" prop="subscript">
              <Select v-model="form.subscript" placeholder="请选择角标">
                <Option :value="-1">无</Option>
                <Option :value="0">HOT</Option>
                <Option :value="1">NEW</Option>
                <Option :value="2">Dubbed</Option>
                <Option :value="3">Exclusive</Option>
                <Option :value="4">Animation</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem label="单集金币价格：" prop="seriesPrice">
              <InputNumber v-model="form.seriesPrice" :min="0" :max="9999" :precision="0" />
            </FormItem>
          </Col>
          <Col :span="24">
            <FormItem label="剧集解锁方式：" prop="playUnlockType">
              <CheckboxGroup v-model="form.playUnlockType" class="unlock-group" @on-change="handleUnlockTypeChange">
                <div class="unlock-row">
                  <Checkbox :label="3">免费解锁</Checkbox>
                  <div v-if="form.playUnlockType.includes(3)" class="unlock-control" @click.stop>
                    前 <InputNumber v-model="form.freeNum" :min="0" :max="playTotal" :precision="0" @on-change="handleAdsRangeChange" /> 集
                  </div>
                </div>
                <div class="unlock-row">
                  <Checkbox :label="0">广告解锁</Checkbox>
                  <div v-if="form.playUnlockType.includes(0)" class="unlock-control" @click.stop>
                    可解锁 <InputNumber v-model="form.adsNum" :min="0" :max="playTotal" :precision="0" /> 集
                  </div>
                </div>
                <div
                v-if="form.playUnlockType.includes(0)"
                class="ads-range-wrapper"
              >
                <FormItem
                  prop="adsEndNum"
                  :rules="[
                    { validator: validateAds }
                  ]"
                >
                  <div class="ads-range-content">
                    <span class="ads-range-text ads-range-label-text">可广告解锁集数</span>
                    <span class="ads-range-text">&nbsp;&nbsp;从</span>
                    <InputNumber
                      v-model="form.adsStartNum"
                      :min="0"
                      :max="9999"
                      @on-change="handleAdsRangeChange"
                    />
                    <span class="ads-range-text">集</span>
                    <span class="ads-range-text">&nbsp;到&nbsp;</span>
                    <InputNumber
                      v-model="form.adsEndNum"
                      :min="0"
                      :max="9999"
                      @on-change="handleAdsRangeChange"
                    />
                    <span class="ads-range-text">集</span>
                  </div>
                </FormItem>
              </div>
                <div class="unlock-row">
                  <Checkbox :label="1">金币解锁</Checkbox>
                  <div v-if="form.playUnlockType.includes(1)" class="unlock-control" @click.stop>
                    从
                    <InputNumber v-model="form.startNum" :min="0" :max="playTotal" :precision="0" />
                    集到
                    <InputNumber v-model="form.endNum" :min="0" :max="playTotal" :precision="0" />
                    集
                  </div>
                </div>
                <div class="unlock-row">
                  <Checkbox :label="2">VIP 解锁</Checkbox>
                  <Button type="text" @click.stop="handleShowEpisode">解锁预览</Button>
                </div>
              </CheckboxGroup>
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem label="Web 端可观看集数：" prop="playWebUnlock">
              <InputNumber v-model="form.playWebUnlock" :min="0" :max="playTotal" :precision="0" />
            </FormItem>
          </Col>
          <Col :span="12">
            <FormItem label="发布状态：" prop="playRelease">
              <i-switch :value="form.playRelease === 1" @on-change="handleReleaseChange"></i-switch>
              <span class="switch-label">{{ form.playRelease === 1 ? '已发布' : '未发布' }}</span>
            </FormItem>
          </Col>
          <Col :span="24">
            <Row :gutter="0">
              <Col :span="6">
                <FormItem label="定时发布：">
                  <i-switch :value="form.scheduledReleaseStatus === 1" @on-change="handleScheduledReleaseChange"></i-switch>
                  <span class="switch-label">{{ form.scheduledReleaseStatus === 1 ? '开启' : '关闭' }}</span>
                </FormItem>
              </Col>
              <Col :span="18" v-if="form.scheduledReleaseStatus === 1">
                <FormItem label="发布时间：" prop="scheduledReleaseTime" :label-width="90">
                  <DatePicker
                    type="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    :editable="false"
                    :options="releaseDateOptions"
                    :value="form.scheduledReleaseTime"
                    placeholder="请选择发布时间"
                    style="width: 260px;"
                    @on-change="$set(form, 'scheduledReleaseTime', $event)"
                  />
                </FormItem>
              </Col>
            </Row>
          </Col>
          <Col :span="24">
            <Row :gutter="0">
              <Col :span="6">
                <FormItem label="定时下架：">
                  <i-switch :value="form.scheduledOfflineStatus === 1" @on-change="handleOfflinePlanChange"></i-switch>
                  <span class="switch-label">{{ form.scheduledOfflineStatus === 1 ? '开启' : '关闭' }}</span>
                </FormItem>
              </Col>
              <Col :span="18" v-if="form.scheduledOfflineStatus === 1">
                <FormItem label="下架时间：" prop="scheduledOfflineTime" :label-width="90">
                  <DatePicker
                    type="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    :editable="false"
                    :options="dateOptions"
                    :value="form.scheduledOfflineTime"
                    placeholder="请选择下架时间"
                    style="width: 260px;"
                    @on-change="$set(form, 'scheduledOfflineTime', $event)"
                  />
                </FormItem>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
      <template #footer>
        <Button @click="editVisible = false">取消</Button>
        <Button type="primary" :loading="submitLoading" :disabled="detailLoading" @click="handleSubmit">
          保存
        </Button>
      </template>
    </Modal>

    <Drawer v-model="showEpisode" title="解锁预览" :width="530" footer-hide :styles="{ zIndex: 9999 }">
      <episodeView v-if="showEpisode" :data="episodeData" />
    </Drawer>

    <Modal v-model="addressVisible" title="修改广告解锁集数">
      <Form :label-width="130">
        <FormItem label="广告可解锁集数：">
          <InputNumber
            v-model="addressSeries"
            placeholder="请输入广告可解锁集数"
            style="width: 100%;"
            :min="0"
            :max="99"
            :precision="0"
          />
        </FormItem>
      </Form>
      <template #footer>
        <Button @click="addressVisible = false">取消</Button>
        <Button type="primary" :loading="addressLoading" @click="handleSubmitAddress">提交</Button>
      </template>
    </Modal>

    <Modal v-model="offlineVisible" title="批量下架" :mask-closable="false">
      <Form ref="offlineFormRef" :model="offlineForm" :rules="offlineRules" :label-width="100">
        <FormItem label="下架方式：" prop="offlineType">
          <ButtonGroup>
            <Button :type="offlineForm.offlineType === 1 ? 'primary' : 'default'" @click="offlineForm.offlineType = 1; $refs.offlineFormRef && $refs.offlineFormRef.validateField('offlineType')">立即下架</Button>
            <Button :type="offlineForm.offlineType === 2 ? 'primary' : 'default'" @click="offlineForm.offlineType = 2; $refs.offlineFormRef && $refs.offlineFormRef.validateField('offlineType')">定时下架</Button>
          </ButtonGroup>
        </FormItem>
        <FormItem v-if="offlineForm.offlineType === 2" label="下架时间：" prop="offlineTime">
          <DatePicker
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            :editable="false"
            :options="dateOptions"
            v-model="offlineForm.offlineTime"
            placeholder="请选择定时下架时间"
            style="width: 100%;"
            @on-change="$refs.offlineFormRef && $refs.offlineFormRef.validateField('offlineTime')"
          />
        </FormItem>
      </Form>
      <template #footer>
        <Button @click="offlineVisible = false">取消</Button>
        <Button type="primary" :loading="offlineLoading" @click="handleSubmitOffline">确定</Button>
      </template>
    </Modal>

    <Episode v-model="episodeVisible" :form="episodeForm" @update:visible="!$event && getData(page.current)" />
    <AdMaterial
      v-model="adMaterialVisible"
      :form="form"
      @update:visible="!$event && getData(page.current)"
    />
    <seriesPlay ref="seriesPlayRef" :data="seriesData" />
    <PromoteModal ref="promoteModalRef" @refresh="getData(page.current)" />
  </Card>
</template>

<script>
import Pages from '@/components/pages'
import dayjs from 'dayjs'
import episodeView from './episode-view.vue'
import Episode from './episode.vue'
import seriesPlay from './series-play.vue'
import AdMaterial from './ad-material.vue'
import PromoteModal from './PromoteModal.vue'
import OpsGenreTagPicker from '@/components/OpsGenreTagPicker.vue'
import PopupUpload from '@/components/Upload/PopupUpload.vue'
import { getLangList } from '@/api/lang'
import { getTypeList } from '@/api/channel'
import { getTagGroups } from '@/api/tag'
import {
  batchUpdateUnlock,
  batchOffline,
  editPlayV2,
  getPlayList,
  getPlayV2Info,
  getSeriesPreview
} from '@/api/play'

const createContentInfo = () => ({
  parentPlayId: null,
  parentPlayName: '',
  playName: '',
  langId: null,
  langName: '',
  fileId: null,
  fileUrl: '',
  playTotal: 0,
  playDesc: '',
  secondPayPoint: null,
  lastSyncTime: ''
})

const createOperationConfig = () => ({
  id: null,
  playName: '',
  secondPayPoint: '',
  fileId: null,
  fileUrl: '',
  playDesc: '',
  playTypeList: [],
  subscript: -1,
  seriesPrice: 0,
  playUnlockType: [],
  adsNum: 0,
  adsStartNum: null,
  adsEndNum: null,
  startNum: 0,
  endNum: 0,
  freeNum: 0,
  playWebUnlock: 0,
  playRelease: 0,
  scheduledReleaseStatus: 0,
  scheduledReleaseTime: null,
  scheduledOfflineStatus: 0,
  scheduledOfflineTime: null
})

export default {
  name: 'PlayMain',
  components: {
    Pages,
    episodeView,
    Episode,
    seriesPlay,
    AdMaterial,
    PromoteModal,
    OpsGenreTagPicker,
    PopupUpload
  },
  data() {
    return {
      addressLoading: false,
      addressSeries: null,
      addressVisible: false,
      adMaterialVisible: false,
      offlineLoading: false,
      offlineVisible: false,
      offlineForm: {
        offlineType: 1,
        offlineTime: null
      },
      offlineRules: {
        offlineType: [
          { required: true, type: 'number', message: '请选择下架方式', trigger: 'change' }
        ],
        offlineTime: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value === null || value === undefined || value === '') {
                callback(new Error('请选择定时下架时间'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      },
      contentInfo: createContentInfo(),
      releaseDateOptions: {
        disabledDate(date) {
          if (!date) return false
          const now = new Date()
          const currentUtcDay = Date.UTC(
            now.getUTCFullYear(),
            now.getUTCMonth(),
            now.getUTCDate()
          )
          const selectedDay = Date.UTC(
            date.getFullYear(),
            date.getMonth(),
            date.getDate()
          )
          return selectedDay < currentUtcDay
        }
      },
      dateOptions: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000
        }
      },
      detailLoading: false,
      editTypeList: [],
      editVisible: false,
      episodeData: [],
      episodeForm: {},
      episodeVisible: false,
      form: createOperationConfig(),
      langList: [],
      tagGroups: [],
      loading: false,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      searchForm: {
        id: '',
        keyword: '',
        langId: '',
        playRelease: '',
        configStatus: '',
        contentTagIds: [],
        playUnlockType: '',
        playTypeList: [],
        subscript: ''
      },
      searchTypeList: [],
      selection: [],
      seriesData: {},
      showEpisode: false,
      submitLoading: false,
      tableData: [],
      columns: [
        {
          type: 'selection',
          width: 60
        },
        {
          title: 'ID',
          key: 'id',
          width: 80
        },
        {
          title: '所属主剧',
          minWidth: 130,
          tooltip: true,
          render: (h, { row }) => h('span', this.displayValue(row.parentPlayName || row.chineseName))
        },
        {
          title: '短剧名称',
          key: 'playName',
          minWidth: 130,
          tooltip: true,
          render: (h, { row }) => h('span', this.displayValue(row.playName))
        },
        {
          title: '封面',
          width: 100,
          slot: 'img'
        },
        {
          title: '所属语言',
          key: 'langName',
          minWidth: 100,
          render: (h, { row }) => h('span', this.displayValue(row.langName))
        },
        {
          title: '已保存/总集数',
          width: 130,
          render: (h, { row }) => h('span', `${row.releaseTotal || 0}/${row.playTotal || 0}`)
        },
        {
          title: '发布状态',
          width: 200,
          slot: 'playRelease'
        },
        {
          title: '内容标签',
          slot: 'contentTag',
          minWidth: 160
        },
        {
          title: 'APP 分类',
          key: 'playTypeName',
          minWidth: 120,
          render: (h, { row }) => h('span', this.displayValue(row.playTypeName))
        },
        {
          title: '角标',
          key: 'subscript',
          width: 90,
          render: (h, { row }) => h('span', this.displaySubscript(row.subscript))
        },
        {
          title: '剧集解锁方式',
          key: 'playUnlockTypeName',
          minWidth: 130,
          render: (h, { row }) => h('span', this.displayValue(row.playUnlockTypeName))
        },
        {
          title: '最近同步时间',
          key: 'lastSyncTime',
          minWidth: 160,
          render: (h, { row }) =>
            h('span', row.lastSyncTime ? dayjs(row.lastSyncTime).format('YYYY-MM-DD HH:mm:ss') : '—')
        },
        {
          title: '操作',
          align: 'center',
          width: 150,
          fixed: 'right',
          slot: 'action'
        }
      ]
    }
  },
  computed: {
    buttonMenu() {
      const list = this.$store.getters.getMenuRules('main/play')
      const result = {}
      list.forEach(item => {
        result[item.menuPath] = true
      })
      return result
    },
    playTotal() {
      return Number(this.contentInfo.playTotal) || 0
    },
    operationRules() {
      const isEmpty = (v) => v === null || v === undefined || v === ''
      return {
        scheduledReleaseTime: [
          {
            validator: (rule, value, callback) => {
              if (this.form.scheduledReleaseStatus === 1 && isEmpty(this.form.scheduledReleaseTime)) {
                return callback(new Error('请选择发布时间'))
              }
              callback()
            },
            trigger: 'change'
          }
        ],
        scheduledOfflineTime: [
          {
            validator: (rule, value, callback) => {
              if (this.form.scheduledOfflineStatus === 1 && isEmpty(this.form.scheduledOfflineTime)) {
                return callback(new Error('请选择下架时间'))
              }
              callback()
            },
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    displayRelease(value) {
      return {
        0: '未发布',
        1: '已发布',
        2: '待发布',
        3: '已下架'
      }[value] || '—'
    },
    displaySubscript(value) {
      return {
        '-1': '无',
        0: 'HOT',
        1: 'NEW',
        2: 'Dubbed',
        3: 'Exclusive',
        4: 'Animation'
      }[value] || '—'
    },
    // 下架时间：定时下架取 scheduledOfflineTime，立即下架取 offlineTime
    getOfflineTime(row) {
      return row.scheduledOfflineTime || row.offlineTime || ''
    },
    displayValue(value) {
      return value === null || value === undefined || value === '' ? '—' : String(value)
    },
    getData(page) {
      this.selection = []
      this.page.current = page || 1
      this.loading = true
      const params = {
        current: this.page.current,
        size: this.page.size,
        id: this.hasValue(this.searchForm.id) ? this.searchForm.id : undefined,
        keyword: this.searchForm.keyword || undefined,
        langId: this.hasValue(this.searchForm.langId) ? this.searchForm.langId : undefined,
        playRelease: this.hasValue(this.searchForm.playRelease) ? this.searchForm.playRelease : undefined,
        configStatus: this.hasValue(this.searchForm.configStatus) ? this.searchForm.configStatus : undefined,
        contentTagIds: this.searchForm.contentTagIds.length ? this.searchForm.contentTagIds.join(',') : undefined,
        playUnlockType: this.hasValue(this.searchForm.playUnlockType) ? this.searchForm.playUnlockType : undefined,
        playTypeList: this.searchForm.playTypeList.length ? this.searchForm.playTypeList.join(',') : undefined,
        subscript: this.hasValue(this.searchForm.subscript) ? this.searchForm.subscript : undefined
      }
      getPlayList(params).then(({ data }) => {
        this.tableData = data.records || []
        this.page.current = data.current
        this.page.total = data.total
      }).finally(() => {
        this.loading = false
      })
    },
    hasValue(value) {
      return value !== '' && value !== null && value !== undefined
    },
    handleOpenEditAddress() {
      this.addressSeries = null
      this.addressVisible = true
    },
    handleSubmitAddress() {
      if (this.addressSeries === null) {
        this.$Message.error('请输入广告可解锁集数')
        return
      }
      this.addressLoading = true
      batchUpdateUnlock({
        playIds: this.selection.map(item => item.id),
        playAdsUnlockNum: this.addressSeries
      }).then(() => {
        this.$Message.success('修改成功')
        this.addressVisible = false
        this.getData(this.page.current)
      }).finally(() => {
        this.addressLoading = false
      })
    },
    handleOpenOfflineModal() {
      this.offlineForm = {
        offlineType: 1,
        offlineTime: null
      }
      this.offlineVisible = true
    },
    handleSubmitOffline() {
      this.$refs.offlineFormRef.validate(valid => {
        if (!valid) return
        this.offlineLoading = true
        const formattedOfflineTime = this.offlineForm.offlineType === 2 && this.offlineForm.offlineTime
          ? dayjs(this.offlineForm.offlineTime).format('YYYY-MM-DD HH:mm:ss')
          : null
        batchOffline({
          playIds: this.selection.map(item => item.id),
          offlineType: this.offlineForm.offlineType,
          offlineTime: formattedOfflineTime
        }).then(() => {
          this.$Message.success('操作成功')
          this.offlineVisible = false
          this.getData(this.page.current)
        }).finally(() => {
          this.offlineLoading = false
        })
      })
    },
    handleSearchLangChange(langId) {
      this.searchForm.playTypeList = []
      this.searchTypeList = []
      if (langId) this.getSearchTypeList(langId)
    },
    getSearchTypeList(langId) {
      return getTypeList({
        current: -1,
        size: -1,
        typeStatus: true,
        langId
      }).then(({ data }) => {
        this.searchTypeList = data.records || []
      })
    },
    getEditTypeList(langId) {
      this.editTypeList = []
      if (!langId) return Promise.resolve()
      return getTypeList({
        current: -1,
        size: -1,
        typeStatus: true,
        langId
      }).then(({ data }) => {
        this.editTypeList = data.records || []
      })
    },
    getLangList() {
      getLangList({ current: -1, size: -1 }).then(({ data }) => {
        this.langList = data.records || []
      })
    },
    loadTagGroups() {
      getTagGroups().then(({ data }) => {
        const list = Array.isArray(data) ? data : []
        this.tagGroups = list.map(group => ({
          name: group.categoryName,
          tags: group.tags || []
        }))
      })
    },
    normalizeArray(value) {
      const list = Array.isArray(value) ? value : String(value || '').split(',')
      return list.filter(item => item !== '').map(item => Number(item))
    },
    normalizeNumber(value, defaultValue = 0) {
      return value === null || value === undefined || value === '' ? defaultValue : Number(value)
    },
    async handleOpenEditModal(row) {
      this.contentInfo = createContentInfo()
      this.form = createOperationConfig()
      this.editTypeList = []
      this.editVisible = true
      this.detailLoading = true
      try {
        const { data } = await getPlayV2Info(row.id)
        const contentInfo = data.contentInfo || {}
        const operationConfig = data.operationConfig || {}
        this.contentInfo = {
          ...createContentInfo(),
          ...contentInfo
        }
        this.form = {
          ...createOperationConfig(),
          id: data.id || row.id,
          playName: operationConfig.playName || '',
          secondPayPoint: this.displayValue(operationConfig.secondPayPoint),
          fileId: operationConfig.fileId !== undefined ? operationConfig.fileId : null,
          fileUrl: operationConfig.fileUrl || '',
          playDesc: operationConfig.playDesc || '',
          playTypeList: this.normalizeArray(operationConfig.playTypeList),
          subscript: this.normalizeNumber(operationConfig.subscript, -1),
          seriesPrice: this.normalizeNumber(operationConfig.seriesPrice),
          playUnlockType: this.normalizeArray(operationConfig.playUnlockType),
          adsNum: this.normalizeNumber(operationConfig.adsNum),
          adsStartNum: this.normalizeNumber(operationConfig.adsStartNum, null),
          adsEndNum: this.normalizeNumber(operationConfig.adsEndNum, null),
          startNum: this.normalizeNumber(operationConfig.startNum),
          endNum: this.normalizeNumber(operationConfig.endNum),
          freeNum: this.normalizeNumber(operationConfig.freeNum),
          playWebUnlock: this.normalizeNumber(operationConfig.playWebUnlock),
          playRelease: this.normalizeNumber(operationConfig.playRelease),
          scheduledReleaseStatus: this.normalizeNumber(operationConfig.scheduledReleaseStatus),
          scheduledReleaseTime: operationConfig.scheduledReleaseTime || null,
          scheduledOfflineStatus: this.normalizeNumber(operationConfig.scheduledOfflineStatus),
          scheduledOfflineTime: operationConfig.scheduledOfflineTime || null
        }
        await this.getEditTypeList(contentInfo.langId)
      } finally {
        this.detailLoading = false
      }
    },
    handleUnlockTypeChange(types) {
      if (!types.includes(3)) this.form.freeNum = 0
      if (!types.includes(0)) {
        this.form.adsNum = 0
        this.form.adsStartNum = null
        this.form.adsEndNum = null
      }
      if (!types.includes(1)) {
        this.form.startNum = 0
        this.form.endNum = 0
      }
    },
    handleAdsRangeChange() {
      this.$refs.formRef.validateField('adsEndNum')
      this.$refs.formRef.validateField('playUnlockType')
    },
    validateAds(rule, value, callback) {
      const total = Number(this.playTotal) || 0
      const isEmpty = (v) => v === null || v === undefined || v === ''
      if (isEmpty(this.form.adsStartNum) && isEmpty(this.form.adsEndNum)) {
        return callback()
      }
      if (this.form.adsStartNum <= (this.form.freeNum || 0)) {
        return callback(new Error('起始集数必须大于免费解锁集数'))
      }
      if ((this.form.adsEndNum || 0) > total) {
        return callback(new Error('结束集数不得超过总集数'))
      }
      if ((this.form.adsEndNum || 0) < this.form.adsStartNum) {
        return callback(new Error('开始集数不能大于结束集数'))
      }
      return callback()
    },
    handleReleaseChange(value) {
      this.form.playRelease = Number(value)
      if (value) {
        this.form.scheduledReleaseStatus = 0
        this.form.scheduledReleaseTime = null
      }
    },
    handleCoverUploadSuccess(data) {
      const fileUrl = data && (data.fileUrl || data.url)
      if (!fileUrl) {
        this.$Message.error('封面图上传失败，请稍后重试')
        return
      }
      this.$set(this.form, 'fileId', data.fileId || data.id)
      this.$set(this.form, 'fileUrl', fileUrl)
      this.$Message.success('封面图上传成功')
    },
    handleScheduledReleaseChange(value) {
      this.form.scheduledReleaseStatus = Number(value)
      if (value) {
        this.form.playRelease = 0
      } else {
        this.form.scheduledReleaseTime = null
      }
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.validateField('scheduledReleaseTime')
      })
    },
    handleOfflinePlanChange(value) {
      this.form.scheduledOfflineStatus = Number(value)
      if (!value) {
        this.form.scheduledOfflineTime = null
      }
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.validateField('scheduledOfflineTime')
      })
    },
    isFutureTime(value) {
      if (!value) return false
      const normalized = typeof value === 'string' ? value.replace(/-/g, '/') : value
      const time = new Date(normalized).getTime()
      return !Number.isNaN(time) && time > Date.now()
    },
    isFutureUtcTime(value) {
      if (!value) return false
      if (value instanceof Date) {
        return Date.UTC(
          value.getFullYear(),
          value.getMonth(),
          value.getDate(),
          value.getHours(),
          value.getMinutes(),
          value.getSeconds()
        ) > Date.now()
      }
      const matched = String(value).trim().match(
        /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/
      )
      if (!matched) return false
      const time = Date.UTC(
        Number(matched[1]),
        Number(matched[2]) - 1,
        Number(matched[3]),
        Number(matched[4] || 0),
        Number(matched[5] || 0),
        Number(matched[6] || 0)
      )
      return time > Date.now()
    },
    validateOperationConfig() {
      if (!this.hasValue(this.form.id)) return '短剧 ID 不能为空'
      if (!this.hasValue(this.form.subscript)) return '请选择角标'
      if (!Number.isInteger(this.form.seriesPrice) || this.form.seriesPrice < 0) return '单集金币价格必须为非负整数'
      if (!this.form.playUnlockType.length) return '请选择剧集解锁方式'
      if (this.form.playUnlockType.some(type => ![0, 1, 2, 3].includes(type))) return '剧集解锁方式无效'

      const quantityFields = [
        ['adsNum', '广告解锁数量'],
        ['startNum', '金币解锁开始集数'],
        ['endNum', '金币解锁结束集数'],
        ['freeNum', '免费解锁数量'],
        ['playWebUnlock', 'Web 端可观看集数']
      ]
      for (const [field, label] of quantityFields) {
        const value = this.form[field]
        if (!Number.isInteger(value) || value < 0 || value > this.playTotal) {
          return `${label}必须为 0~${this.playTotal} 的整数`
        }
      }

      if (this.form.playUnlockType.includes(1) && this.form.startNum >= this.form.endNum) {
        return '金币解锁开始集数必须小于结束集数'
      }
      const isEmptyRangeValue = (v) => v === null || v === undefined || v === ''
      if (
        this.form.playUnlockType.includes(0) &&
        (!isEmptyRangeValue(this.form.adsStartNum) || !isEmptyRangeValue(this.form.adsEndNum))
      ) {
        const total = Number(this.playTotal) || 0
        if (this.form.adsStartNum <= (this.form.freeNum || 0)) {
          return '广告解锁起始集数必须大于免费解锁集数'
        }
        if ((this.form.adsEndNum || 0) > total) {
          return '广告解锁结束集数不得超过总集数'
        }
        if ((this.form.adsEndNum || 0) < this.form.adsStartNum) {
          return '广告解锁开始集数不能大于结束集数'
        }
      }
      if (this.form.scheduledReleaseStatus === 1) {
        if (this.form.playRelease !== 0) return '开启定时发布时，短剧必须为未发布状态'
        if (!this.isFutureUtcTime(this.form.scheduledReleaseTime)) return '定时发布时间必须晚于当前时间'
      }
      if (this.form.scheduledOfflineStatus === 1) {
        if (this.form.scheduledOfflineTime === null || this.form.scheduledOfflineTime === undefined || this.form.scheduledOfflineTime === '') {
          return '请选择定时下架时间'
        }
        if (!this.isFutureTime(this.form.scheduledOfflineTime)) return '定时下架时间必须晚于当前时间'
      }
      return ''
    },
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        const errorMessage = this.validateOperationConfig()
        if (errorMessage) {
          this.$Message.error(errorMessage)
          return
        }
        const secondPayPointValue = this.form.secondPayPoint === '—' ? '' : this.form.secondPayPoint
        const params = {
          id: this.form.id,
          playName: this.form.playName,
          secondPayPoint: this.normalizeNumber(secondPayPointValue, null),
          playDesc: this.form.playDesc,
          fileId: this.form.fileId,
          playTypeList: [...this.form.playTypeList],
          subscript: this.form.subscript,
          seriesPrice: this.form.seriesPrice,
          playUnlockType: [...this.form.playUnlockType],
          adsNum: this.form.adsNum,
          adsStartNum: this.form.playUnlockType.includes(0) ? this.form.adsStartNum : 0,
          adsEndNum: this.form.playUnlockType.includes(0) ? this.form.adsEndNum : 0,
          startNum: this.form.startNum,
          endNum: this.form.endNum,
          freeNum: this.form.freeNum,
          playWebUnlock: this.form.playWebUnlock,
          playRelease: this.form.playRelease,
          scheduledReleaseStatus: this.form.scheduledReleaseStatus,
          scheduledReleaseTime: this.form.scheduledReleaseStatus === 1 ? this.form.scheduledReleaseTime : null,
          scheduledOfflineStatus: this.form.scheduledOfflineStatus,
          scheduledOfflineTime: this.form.scheduledOfflineStatus === 1 ? this.form.scheduledOfflineTime : null
        }
        this.submitLoading = true
        editPlayV2(params).then(() => {
          this.$Message.success('保存成功')
          this.editVisible = false
          this.getData(this.page.current)
        }).finally(() => {
          this.submitLoading = false
        })
      })
    },
    fileEpisode() {
      this.episodeData = Array.from({ length: this.playTotal }, (_, index) => {
        const episode = index + 1
        return {
          free: this.form.playUnlockType.includes(3) && this.form.freeNum >= episode,
          ads: this.form.playUnlockType.includes(0) && episode >= (this.form.adsStartNum || 0) && episode <= (this.form.adsEndNum || 0),
          coins: this.form.playUnlockType.includes(1) && this.form.startNum < episode && this.form.endNum >= episode - 1,
          vip: this.form.playUnlockType.includes(2)
        }
      })
    },
    handleShowEpisode() {
      if (!this.playTotal) {
        this.$Message.error('当前短剧总集数为 0，无法预览')
        return
      }
      this.fileEpisode()
      this.showEpisode = true
    },
    handleOpenEditEpisode(row) {
      this.episodeForm = { ...row }
      this.episodeVisible = true
    },
    handleOpenAdMaterial(row) {
      this.form = row
      this.adMaterialVisible = true
    },
    handlePreviewSeries(row) {
      if (!row.releaseTotal) return
      getSeriesPreview({
        current: 1,
        size: 500,
        playId: row.id
      }).then(({ data }) => {
        this.seriesData = data
        if (data.seriesList && data.seriesList.length) {
          this.$nextTick(() => {
            this.$refs.seriesPlayRef.visible = true
          })
        } else {
          this.$Message.error('该短剧无可预览剧集')
        }
      })
    },
    handleReset() {
      this.searchForm = {
        id: '',
        keyword: '',
        langId: '',
        playRelease: '',
        configStatus: '',
        contentTagIds: [],
        playUnlockType: '',
        playTypeList: [],
        subscript: ''
      }
      this.searchTypeList = []
      this.getData()
    }
  },
  mounted() {
    this.getData()
    this.getLangList()
    this.loadTagGroups()
  },
  activated() {
    const playId = this.$route.query.playId
    if (playId) {
      this.searchForm.id = playId
      this.$router.replace({ path: '/play', query: {} })
      // 打开短剧运营配置详情弹窗（从主剧管理"查看短剧"跳转而来）
      this.handleOpenEditModal({ id: playId })
    }
  }
}
</script>

<style scoped lang="less">
.search-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 10px;

  & > * {
    width: 200px;
    margin: 0 10px 10px 0;
  }

  .ivu-btn {
    width: auto;
  }
}

.content-tag-filter {
  width: 320px;
}

.table-wrapper {
  height: 100%;
}

.cover-cell {
  height: 85px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 64px;
    max-height: 80px;
    cursor: pointer;
  }
}

.release-time {
  margin-top: 4px;
  color: #999;
  font-size: 11px;
}

.content-tag-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: normal;
  line-height: 1.4;
}

.offline-time {
  color: #ed4014;
}

.action-list {
  display: flex;
  flex-direction: column;

  a {
    margin-top: 5px;
  }
}

.detail-cover {
  width: 90px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #eee;

  img {
    max-width: 100%;
    max-height: 100%;
    cursor: pointer;
  }
}

.unlock-group {
  width: 100%;
}

.unlock-row {
  min-height: 42px;
  display: flex;
  align-items: center;
}

.unlock-control {
  margin-left: 20px;
}

.ads-range-wrapper {
  margin-top: 12px;
  padding-left: 24px;
  margin-bottom: 4px;

  /deep/ .ivu-form-item {
    margin-bottom: 16px;
  }
  /deep/ .ivu-form-item-content {
    position: relative;
    margin-left: 0 !important;   /* 抵消 Form 的 label-width=140 偏移 */
  }
  /deep/ .ivu-form-item-error-tip {
    position: static;
    padding-top: 4px;
    padding-bottom: 2px;
    line-height: 18px;
    white-space: normal;
    word-break: break-all;
    max-width: none;
  }
}

.ads-range-content {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.ads-range-text {
  line-height: 32px;
  color: #515a6e;
}

.ads-range-label-text {
  color: #222;
  font-weight: 500;
}

.switch-label {
  margin-left: 8px;
  color: #666;
}

.layout-card {
  height: 100%;

  /deep/ .ivu-card-body {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}

/deep/ .play-edit-modal .ivu-modal-body {
  max-height: 70vh;
  overflow-y: auto;
}

/deep/ .ivu-drawer-wrap,
/deep/ .ivu-drawer-mask {
  z-index: 2000;
}

/deep/ .ivu-table-fixed {
  pointer-events: none;

  & > * {
    pointer-events: auto;
  }
}

.content-info-card {
  background: #f8f8f9;
  border-radius: 4px;
  margin-bottom: 16px;
  overflow: hidden;
}

.content-info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #e8eaec;
}

.content-info-title {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #1c2438;
}

.content-info-sync {
  font-size: 12px;
  color: #999;
}

.content-info-body {
  padding: 16px;
}

.content-info-row-fields {
  display: flex;
  flex-wrap: nowrap;
  gap: 24px;
  margin-bottom: 12px;
}

.content-info-row-fields .content-info-item {
  flex: 1;
  min-width: 0;
}

.content-info-divider {
  border-top: 1px dashed #d9d9d9;
  margin: 12px 0;
}

.content-info-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 12px;
}

.content-info-row:last-child {
  margin-bottom: 0;
}

.content-info-item {
  flex: 1;
  min-width: 160px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.content-info-item-full {
  flex: 1 1 100%;
}

.content-info-label {
  font-size: 12px;
  color: #999;
}

.content-info-value {
  font-size: 14px;
  color: #333;
  word-break: break-all;
}

.content-info-value-desc {
  line-height: 1.6;
}

.cover-upload-wrapper {
  display: flex;
  align-items: center;
}

.cover-preview {
  width: 60px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cover-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}
</style>
